<template>
    <div>
        <b-card>
          <b-row>
            <b-col cols="6">
              <b-row>
                <b-col cols="4">Select Template:</b-col>
                <b-col cols="8 text-left">
                  <b-form-select :plain="true" v-model="selectedTemplateDocId" :options="availableTemplateDocs" @change="handleSelectedTemplate" ></b-form-select>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6">
              <b-row>
                <b-col cols="4">Select Page:</b-col>
                <b-col cols="8 text-left">
                  <b-form-select :plain="true" v-model="selectedTemplateId"  :options="availableTemplates" @change="fetchTemplateVersion"></b-form-select>
                  <div style="color:red" v-if="selectedTemplateId == null" >Please select Page.</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="6">
              <b-row>
                <b-col cols="4">Select Version:</b-col>
                <b-col cols="6 text-left">
                  <b-form-select :plain="true" v-model="selectedTemplateVersion" :options="availableTemplateVersions"></b-form-select>
                </b-col>
                <b-btn size="sm" variant="secondary" :disabled="!(selectedTemplateDocId && selectedTemplateId && selectedTemplateVersion)" @click="fetchAutoCorrectData"> Fetch </b-btn>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
          </b-row>
        </b-card>
        <b-card>
          <h4>Auto Correct Fields:
            <div class="float-right add-field-btn">
            <b-button type="submit" size="md" variant="secondary" :disabled="!(selectedTemplateDocId && selectedTemplateId && selectedTemplateVersion)" @click="displayClearWarning()" class="mt-0"> Clear History </b-button>
          </div>
          </h4>
        </b-card>
        <b-row v-if ="wordMappings.length > 0">
          <b-col sm="3" v-for="word in wordMappings" :key="word.id">
          <b-card
            border-variant="secondary"
          >
          <h6>{{word.key}}
          <div class="float-right add-field-btn">
            <b-button type="submit" size="sm" variant="danger" @click="displayWarning(word)" class="mt-0"><i class="fa fa-trash"></i></b-button>
          </div></h6>
          </b-card>
          </b-col>
        </b-row>
        <b-row v-if ="wordMappings.length < 1 && loaded">
          <b-col sm="12">
            <center><h5>No Data Found</h5></center>
          </b-col>
        </b-row>
         <b-modal centered
            id="deleteModal"
            ref="deleteModal"
            :title="$t('COMMON.DELETE_CONFIRM')"
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            :ok-title="$t('COMMON.DELETE')"
            :cancel-title="$t('COMMON.CANCEL')"
            ok-variant="secondary"
            cancel-variant="light"
            @cancel="cancel"
            @keydown.native.enter="deleteAccountToken"
            @ok="deleteAccountToken" >
            <div class="delete-warning">
              <p>{{$t('COMMON.DEL_AUTO_CORRECT')}}</p>
            </div>
          </b-modal>
          <b-modal centered
            id="deleteAllModal"
            ref="deleteAllModal"
            :title="$t('COMMON.DELETE_CONFIRM')"
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            :ok-title="$t('COMMON.CLEAR')"
            :cancel-title="$t('COMMON.CANCEL')"
            ok-variant="secondary"
            cancel-variant="light"
            @cancel="cancelClearWarning"
            @keydown.native.enter="deleteFromWordDataSetDictinory"
            @ok="deleteFromWordDataSetDictinory" >
            <div class="delete-warning">
              <p>{{$t('COMMON.DEL_AUTO_CORRECT_HISTORY')}}</p>
            </div>
          </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      name: '',
      accountTokens: [],
      token_id: null,
      availableTemplateDocs: [],
      availableTemplates: [],
      selectedTemplateDocId: null,
      selectedTemplateId: null,
      showVersionsRow: false,
      selectedTemplateVersion: null,
      availableTemplateVersions: [],
      wordMappings: [],
      currentDeleteWord: {},
      loaded: false
    }
  },
  mounted () {
    this.fetchTemplateDocs()
  },
  computed: {
    ...mapGetters(['idToken'])
  },
  methods: {
    handleSelectedTemplate (newValue) {
      this.fetchData(newValue)
    },
    displayWarning (word) {
      this.currentDeleteWord = word
      this.$refs['deleteModal'].show()
    },
    cancel () {
      this.$refs['deleteModal'].hide()
    },
    displayClearWarning () {
      this.$refs['deleteAllModal'].show()
    },
    cancelClearWarning () {
      this.$refs['deleteAllModal'].hide()
    },
    deleteAccountToken () {
      Vue.axios.post('/settings/word_dataset/delete_auto_correct_mappings', this.currentDeleteWord, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          this.$refs['deleteModal'].hide()
          if (response.data.status) {
            this.wordMappings = this.wordMappings.filter((word, index) => { return word.id !== this.currentDeleteWord.id })
            Vue.toasted.show(this.$t('COMMON.MSG_DELETE'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_DELETE_ERR'), { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    deleteFromWordDataSetDictinory () {
      let params = new window.FormData()
      params.append('template_id', this.selectedTemplateId)
      params.append('revision_id', this.selectedTemplateVersion)
      Vue.axios.post('/settings/word_dataset/delete_all_auto_correct_mappings', params, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          this.$refs['deleteAllModal'].hide()
          if (response.data.status) {
            Vue.toasted.show(this.$t('COMMON.MSG_DELETE_HISTORY'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_DELETE_ERR'), { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchData (newValue) {
      let params = new window.FormData()
      params.append('template_doc_id', newValue)
      Vue.axios.post('/settings/word_dataset/fetch_templates', params, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          let result = res.data
          this.showVersionsRow = true
          this.availableTemplates = [{text: 'Select Page', value: null, disabled: true}].concat(result.templates)
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchTemplateVersion (newValue) {
      this.selectedTemplateVersion = null
      if (newValue) {
        Vue.axios.get('/settings/word_dataset/fetch_versions?template_id=' + newValue, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            let result = res.data
            this.availableTemplateVersions = [{text: 'Select Page Version', value: null, disabled: true}].concat(result.versions)
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      }
    },
    fetchTemplateDocs () {
      Vue.axios.get('/settings/word_dataset', { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.availableTemplateDocs = [{ text: 'Select Template', value: null, disabled: true }].concat(res.data.available_templates)
        })
        .catch(error => {
          if (error.status === 401) {
            console.log(this.$t('COMMON.MSG_EXPIRED'))
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchAutoCorrectData () {
      Vue.axios.get('/settings/word_dataset/get_template_mappings', { headers: { Authorization: `Bearer ${this.idToken}` }, params: { template_id: this.selectedTemplateId, revision_id: this.selectedTemplateVersion } })
        .then(res => {
          this.loaded = true
          this.wordMappings = res.data.word_mapping
        })
        .catch(error => {
          if (error.status === 401) {
            console.log(this.$t('COMMON.MSG_EXPIRED'))
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>

.text-left {
  padding-top: 5px;
}

.btn-sm, .btn-group-sm > .btn {
  height: 35px;
  margin-top: 5px;
}
.delete-warning {
  font-size : 1rem;
  color: red;
}
.card {
  background: #ebeff3;
  border-radius: 10px;

  .bar {
    width: 100%;
    height: 10px;
    border-radius: 10px 10px 0 0;
  }

  .card-header {
    border-radius: 10px 10px 0 0;
    background-color: #e7e7e7;
    padding: 1rem;
  }
}

.top-layer {
  justify-content: space-between;
  padding: 0 1.25em;
}

.modal-button {
  border-radius: 0px;
  margin-left: 5px;
  margin-right: 5px;
  padding-left: 3rem;
  padding-right: 3rem;
  float: right !important;
}

.required {
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/settings/autoCorrect.vue